import React from 'react';
import ContactForm from './ContactForm'
import logo from './images/logo.svg';
import book from './images/book.svg';
import clock from './images/clock.svg';
import person from './images/person.svg';
import puzzle from './images/puzzle.svg';
import LinkedInIcon   from '@material-ui/icons/LinkedIn';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './App.css';
import slide1 from './images/Artboard – 2.svg';
import slide2 from './images/Artboard – 3.svg';
import slide3 from './images/Artboard – 4.svg';
import slide4 from './images/Artboard – 5.svg';
import slide5 from './images/Artboard – 6.svg';
import slide6 from './images/Artboard – 7.svg';
import slide7 from './images/Artboard – 8.svg';
import slide8 from './images/Artboard – 9.svg';
import slide9 from './images/Artboard – 10.svg';



function App() {

  return (
    <div className="App container">
      <Navbar/>
      <div className='body1 row'>
        <ImageSlider/>
        <PromotionalText/>
        <ContactForm/>
      </div>
      <div className='body2'>
       <FeaturePanel/>
      </div>
      <Footer/>
    </div>
  );
}

export default App;

const Navbar = () =>{

  return (
    <div className='navbar row'>
      <img src={logo} className="app-logo" alt="logo" />
      <p className='info'> Contact us  +47 917 127 86  | hbook@apply.no</p>
    </div>
  );
}

const Footer = () => {
  return(
    <footer className="footer row container-end">
  {/* <i className="w3-hover-opacity"><InstagramIcon style={{ fontSize: 50 }} /></i>  */}
  <p className="align-right">Product by <a href="https://apply.no/" target="_blank" rel="noreferrer">Apply As</a></p>
  <div style={{padding:"10px"}}></div>
  <p>Follow us on: </p> 
  <i className="w3-hover-opacity"><a href="https://no.linkedin.com/company/apply-s-rco-as" target="_blank" rel="noreferrer"><LinkedInIcon style={{ fontSize: 40 }}/></a></i>
</footer>
  );
}

const PromotionalText = () => {
  return (        
    <div className='promotion-text'>
      <h1>HBOOK</h1>
      <h2>Information at your fingertips</h2>
      <article>Hbook is Apply’s digital handbook, designed <br/>
        with an intuitive user interface aimed at <br/>
        users of all level of digital maturity. <br/><br/>
        Display several types of information in the <br/>
        same format from multiple sources.
      </article>
      <div className='space'> <br/><br/></div>
      <article>Available on iOS, Android and Web</article>
    </div>
  );
}

const ImageSlider = () => {
  return(
  <Carousel showThumbs={false} showStatus = {false} interval={3000} transitionTime={150} centerSlidePercentage={100} > 
    <div><img src={slide1} alt="slide1" className="slider-image"/></div>
    <div><img src={slide2} alt="slide2" className="slider-image"/></div>
    <div><img src={slide3} alt="slide3" className="slider-image"/></div>
    <div><img src={slide4} alt="slide4" className="slider-image"/></div>
    <div><img src={slide5} alt="slide5" className="slider-image"/></div>
    <div><img src={slide6} alt="slide6" className="slider-image"/></div>
    <div><img src={slide7} alt="slide7" className="slider-image"/></div>
    <div><img src={slide8} alt="slide8" className="slider-image"/></div>
    <div><img src={slide9} alt="slide9" className="slider-image"/></div>
  </Carousel>);
}

const FeaturePanel = () => {
  return (    
    <div className='row container-space-between'>
      <div className='features'>
        <img src={book} className="icon" alt="book"></img>
        <article>Always display<br/>updated information</article>
      </div>
      <div className='features'>
        <img src={clock} className="icon" alt="clock"></img>
        <article>Decrease time spent<br/>searching for information</article>
      </div>
      <div className='features'>
        <img src={person} className="icon" alt="person"></img>
        <article>More than 2000<br/>active users </article>
      </div>
      <div className='features'>
        <img src={puzzle} className="icon" alt="puzzle"></img>
        <article>Optimize onboarding,<br/>training and operation</article>
      </div>
  </div>);
}
